// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  A1: (t, data?, options?) => t('enum.language-proficiency.a1.name', data, options),
  A2: (t, data?, options?) => t('enum.language-proficiency.a2.name', data, options),
  B1: (t, data?, options?) => t('enum.language-proficiency.b1.name', data, options),
  B2: (t, data?, options?) => t('enum.language-proficiency.b2.name', data, options),
  C1: (t, data?, options?) => t('enum.language-proficiency.c1.name', data, options),
  C2: (t, data?, options?) => t('enum.language-proficiency.c2.name', data, options),
  Native: (t, data?, options?) => t('enum.language-proficiency.native.name', data, options),
  /* eslint-enable max-len */
};
